var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogoCompact(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 52 52",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.8735 9.65472L28.9896 9.65473L29.4771 7.54321C29.9425 5.5273 28.6856 3.5158 26.6697 3.0504C24.6538 2.58499 22.6423 3.84191 22.1769 5.85782L21.3003 9.65473L18.1842 9.65472L16.4545 17.147H18.6287L13.2606 40.3986C15.27 42.0841 17.5408 43.4683 20.0034 44.4824H20.0071L26.318 17.147H28.5056L24.9128 32.7094C24.4474 34.7253 25.7043 36.7368 27.7202 37.2022C29.7361 37.6676 31.7476 36.4107 32.213 34.3947L36.195 17.147L33.9994 17.147L34.2143 16.2161C34.6797 14.2002 33.4228 12.1887 31.4069 11.7232C29.391 11.2578 27.3795 12.5148 26.9141 14.5307L26.3101 17.147L24.1438 17.147L25.8735 9.65472Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoCompact);
export default __webpack_public_path__ + "static/media/logoCompact.1529e884728a54e300ff0b951b232dc2.svg";
export { ForwardRef as ReactComponent };